// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__P4jIM","name":"styles_name__CsWPx","phone":"styles_phone__1O8hk"};